module.exports = __webpack_public_path__ + "img/cplusplus.8fd53f9c.png";